import contractaddress from "@/constants/contractaddress.json";
import synthetixTokens from "@/constants/synthetix.json";
import ethabi from "web3-eth-abi";
const { keccak256,toWei,fromWei} = require('web3-utils');
import { ethers } from 'ethers';

import {generatePseudoRandomSalt,getNow} from './utils.js';
import BigNumber from "bignumber.js";
import axios from  'axios';
import cookie from 'cookiejs';


const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000';

const swapfeeaddress ='0x15d34aaf54267db7d7c367839aaf71a00a2c6a65';
const royaltiesaddress = '0x9965507d1a55bcc2695c58ba16fb37d819b0a4dc';


export const getTokenByName = (chainID, name) => {
    if(contractaddress[chainID]==null){
        throw new Error('chainID error ');
    }
  console.log(contractaddress);
  return  contractaddress[chainID][name];
};

import {
    useABI_ERC21_MyNFT,useABI_ERC21_exchange,
    useABI_ERC20_weth
} from '@/contacthelp/useContract.js';

import config from '@/config/config.js';


export function getMyNftcontract(library, account, chainID,nftaddress) {
    console.log('getArtcontract');
    const address = nftaddress||getTokenByName(chainID,'MyNFT');
    const Contract = useABI_ERC21_MyNFT(library,
        account,
        address,
        true);
    return Contract;

}

export function exchange(library, account, chainID) {
    console.log('getArtcontract');
    const address = getTokenByName(chainID,'AdminUpgradeabilityProxy');
    const Contract = useABI_ERC21_exchange(library,
        account,
        address,
        true);
    return Contract;

}


export function getweth(library, account, chainID,contractaddress) {
  console.log('getArtcontract');
  const address = contractaddress||getTokenByName(chainID,'WETH');
  const Contract = useABI_ERC20_weth(library,
      account,
      address,
      true);
  return Contract;

}


export async function mintMyNFT(library, account, chainID,tokenID){
    const MyNftcontract = getMyNftcontract(library, account, chainID);
    console.log(MyNftcontract);
    const res = await  MyNftcontract.mint(tokenID);
    console.log(res);
    const txlast = await res.wait([1]);
    console.log(txlast.status);
    

}

export async  function  getmynftList(library, account, chainID){
    const MyNftcontract = getMyNftcontract(library, account, chainID);
    console.log(MyNftcontract);
    let balance  = await MyNftcontract.balanceOf(account);
    // balance=Web3.utils.hexToNumber(balance);
    balance=balance.toNumber();
    let index = 0;

    const list =[];
    for (index; index < balance; index++) {
        console.log('---');
        const token   = await MyNftcontract.tokenOfOwnerByIndex(account,index);

        list.push({
          tokenID:token.toNumber(),
          tokenAddress:MyNftcontract.address
        });
    }

    return list;
    

}

export async  function  getAllList(library, account, chainID){
  const MyNftcontract = getMyNftcontract(library, account, chainID);
  console.log(MyNftcontract);
  let balance  = await MyNftcontract.totalSupply();
  // balance=Web3.utils.hexToNumber(balance);
  balance=balance.toNumber();
  let index = 0;

  const list =[];
  for (index; index < balance; index++) {
      console.log('---');
      const token   = await MyNftcontract.tokenByIndex(index);

      list.push({
        tokenID:token.toNumber(),
        tokenAddress:MyNftcontract.address
      });
  }

  return list;
  

}

export async function approveAll(library, account, chainID,nftaddress){
    const MyNftcontract = getMyNftcontract(library, account, chainID,nftaddress);

    const delegateaddress = getTokenByName(chainID,"ERC721Delegate");


    const res =await MyNftcontract.setApprovalForAll(delegateaddress, true);
    console.log(res);
    const txlast = await res.wait([1]);
    console.log(txlast.status);
    
}

export async function checkapproveAll(library, account, chainID,nftaddress){
    const MyNftcontract = getMyNftcontract(library, account, chainID,nftaddress);
    const delegateaddress = getTokenByName(chainID,"ERC721Delegate");

    const res =await MyNftcontract.isApprovedForAll(account,delegateaddress);
    return res;

}



export function getsellToken (){
  this.list=[]; 
  this.originallist=[]; 
  
}
getsellToken.prototype.xxx="sssss";
getsellToken.prototype.addnft= function(Nftcontractaddress,tokenId,Price){
      // NFT资产
      const tokenInfo = {
        address: Nftcontractaddress,
        tokenId: tokenId.toString()
    };

    // 编码tokenInfo
    const data = ethabi.encodeParameter(
        'tuple(address, uint256)[]',
      [[tokenInfo.address, tokenInfo.tokenId]]
    );

    // 设置tokenId为1的NFT, 价格为1ETH
    const sellToken = {
        price: toWei(Price),
        data: data
      };
      this.list.push(sellToken);
      this.originallist.push(tokenInfo);
};

getsellToken.prototype.addnftcollection=function(Nftcontractaddress,Price){
      // 对整个collection出offer, tokenId写为0
      const collectionTokenInfo = {
        address: Nftcontractaddress,
        tokenId: '0'
      };
  
      
      const data = ethabi.encodeParameter(
          'tuple(address, uint256)[]',
        [[collectionTokenInfo.address, collectionTokenInfo.tokenId]]
      );
  
      const buyToken = {
        price: toWei(Price),
        data: data
      };
      this.list=[];
      this.originallist=[];
      this.list.push(buyToken);
      this.originallist.push(collectionTokenInfo);

};

getsellToken.prototype.getList= function(){
  return this.list;
};

getsellToken.prototype.getListforServer= function(){
  if(this.originallist.length!=this.list.length){
    console.log('need originallist and list');
    return;
  }
  const items=[];
   for (let index = 0; index < this.originallist.length; index++) {
     const element = this.originallist[index];
     items.push( {
      "contract_address": element.address,
      "token_id": element.tokenId,
      "price": this.list[index].price
     });
     
   }
  
  return items;
};

getsellToken.prototype.getorderForServer=function(){
  return this.orderForServer;
};



getsellToken.prototype.getunitaddress = function(chainID,unit){
  if(unit=="eth"){
    return ZERO_ADDRESS;
  }
  if(unit=="weth"){
    return getTokenByName(chainID,'WETH');
  }
};
getsellToken.prototype.sellOrder = async function(library, account, chainID,expireTime,unit){
   const sellTokens = this.getList();
    if(!(sellTokens instanceof Array)){
      console.log("need sellTokens");
    }
    // orderType 1 代表卖单
    const orderType = 1; // sell
    const dataMask="0x";

    //订单详情
    const offChainOrder=await this.buildOrder(library, account, chainID,expireTime,unit,orderType,dataMask);
     // 组合出线下签名的卖单数据
    
  
      const eye = exchange(library, account, chainID);
      console.log(eye,offChainOrder);
      // 测试验证
      const result = await eye.verifyOrderSignature(offChainOrder);
      console.log('verification',result);
      return offChainOrder;

    

};
getsellToken.prototype.buyOrderOffer = async function(library, account, chainID,expireTime,unit){
  const sellTokens = this.getList();
   if(!(sellTokens instanceof Array)){
     console.log("need sellTokens");
   }
   // orderType 3 代表买单
   const orderType = 3; // buy
   const dataMask="0x";
   //订单详情 
   const offChainOrder=await this.buildOrder(library, account, chainID,expireTime,unit,orderType,dataMask);
     // 组合出线下签名的卖单数据
 
     const eye = exchange(library, account, chainID);
     console.log(eye,offChainOrder);
     // 测试验证
     const result = await eye.verifyOrderSignature(offChainOrder);
     console.log(result);
     return offChainOrder;

   

};
getsellToken.prototype.buycollectionOrderOffer=async function(library, account, chainID,expireTime,unit){
  const collectionTokenInfo = this.getList();
   if(!(collectionTokenInfo instanceof Array)){
     console.log("need sellTokens");
   }
   if(collectionTokenInfo.length<1){
    console.log("need sellTokens");
    return;
   }

   console.log('BigNumber',new BigNumber(2));
   //
   const maskId = (new BigNumber(2)).pow(256).minus(1);
   const collectionOrderMask = ethabi.encodeParameter(
       'tuple(address, uint256)[]',
       [[this.originallist[0].address, maskId.toFixed(0)]]
   );
   // orderType 3 代表买单
   const orderType = 3; // buy
   const dataMask=collectionOrderMask;
   //订单详情 
   const offChainOrder=await this.buildOrder(library, account, chainID,expireTime,unit,orderType,dataMask);
     // 组合出线下签名的卖单数据
 
     const eye = exchange(library, account, chainID);
     console.log(eye,offChainOrder);
     // 测试验证
     const result = await eye.verifyOrderSignature(offChainOrder);
     console.log(result);
     return offChainOrder;

};


getsellToken.prototype.buildOrder = async function(library, account, chainID,expireTime,unit,orderType,dataMask){
  this.orderForServer={};
  const sellTokens = this.getList();
   if(!(sellTokens instanceof Array)){
     console.log("need sellTokens");
   }

   const fees=[];

   sellTokens.forEach((item)=>{
    fees.push([
      {
        percentage: 2500,
        to: swapfeeaddress
      },
      {
        percentage: 5000,
        to: royaltiesaddress
      }
    ]);

   });


   // 订单详情
   const orderInfo = {
       salt: generatePseudoRandomSalt().toString(),  // 随机种子
       user: account, // 卖家地址
       network: chainID, // 当前网络的chainId
       intent: orderType, // 卖单
       delegateType: 1, // 写死为1
       deadline: expireTime, // 过期时间
       currency: this.getunitaddress(chainID,unit), // 出售ERC20的地址, 如果为ETH原生资产, 参数为0x000...0
       dataMask: dataMask, // 卖单写死为'0x'
       items: sellTokens, // 本次卖单的token, 可以是多个 sellToken1 sellToken2
       fees: fees, //有多个sellTokens 就有多个fees
           
        // fees为订单收取的手续费用, 如果有多个卖单, 需要为每一个卖单设置手续费
         // 这里fee是一个数组, 数组第一项表示交易所收取的费用, 2500表示0.25%, 数组第二项表示NFT的版税
         // 注意: 每一个fee必须有两个item, 一个交易所地址和版税收取地址, percentage可为0, to可为ZERO_ADDRESS
     };

     const orderItemPattern = orderInfo.items.map(item => [item.price, item.data]);
   const feeItemPattern = orderInfo.fees.map(item => item.map(e => [e.percentage, e.to]));

   const orderHash = keccak256(ethabi.encodeParameters(
       ['uint256', 'address', 'uint256', 'uint256', 'uint256', 'uint256',
         'address', 'bytes', 'uint256', 'tuple(uint256, bytes)[]', 'uint256', 'tuple(uint256, address)[][]'],
       [
         orderInfo.salt, orderInfo.user, orderInfo.network, orderInfo.intent,
         orderInfo.delegateType, orderInfo.deadline, orderInfo.currency, orderInfo.dataMask,
         orderInfo.items.length, orderItemPattern, orderInfo.fees.length, feeItemPattern]
   ));
   

     const msg = orderHash;
     const params = [msg,account];
     const method = "personal_sign";
     console.log('--');
     const signature_ = await library.provider.request({method, params, } );
   
    const signature = ethers.utils.splitSignature(signature_);
     console.log('signature',signature);
     console.log('orderInfo',JSON.stringify(orderInfo));


    // 组合出线下签名的卖单数据
   const offChainOrder = {
       ...orderInfo,
       r: signature.r,
       s: signature.s,
       v: signature.v,
       signVersion: 1 // 写死为1
     };
     this.orderForServer=orderInfo;
     this.orderForServer.order_hash=orderHash;
     this.orderForServer.signature=signature_;
     this.orderForServer.items=this.getListforServer();
     this.orderForServer.create_at=getNow();

     this.orderForServer.delegate_type =orderInfo.delegateType;
     this.orderForServer.data_mask =orderInfo.dataMask;



     return offChainOrder;

   

};

getsellToken.prototype.sendOrderToserver = async function(){
  const data = this.getorderForServer();
  const access_token=cookie.get('access_token');
  const result = await  axios({
    method: 'post',
    url: '/api/order/new?access_token='+access_token,
    data: data
  });
  return result.data;
};

getsellToken.prototype.getTokenOrderListFromserver = async function(chainID,tokenId,order_type){
  const NFTaddress =   getTokenByName(chainID,'MyNFT');
  
  const result = await  axios({
    method: 'get',
    url: "/api/orders/"+NFTaddress+"/"+tokenId+"?order_type="+order_type,
  });
  return result.data;
};


export async function usersign(library,msg,account){
  
     const params = [msg,account];
     const method = "personal_sign";
     console.log('--');
     const signature_ = await library.provider.request({method, params, } );
     //user 用户名称  content 加密内容  signature 签名
     const result = await  axios({
      method: 'get',
      url: "/api/accessToken?user="+account+"&content="+encodeURI(msg)+"&signature="+signature_,
    });

    //cookie('access_token',result.data,365);

    cookie('access_token',result.data, { 'expires': 365, 'path': '/' });

     return result;
}


export  function wapOrderdetails(chainID){
    //授权地址
    this.delegateaddress = getTokenByName(chainID,"ERC721Delegate");
    this.orderNum=null;
    this.orders=[];
    this.details=[];
    this.priceAll=0;
}

wapOrderdetails.prototype.buildorder=function(offChainOrder,tokenIndexOfChainOrder,orderType){
        const orderItemPattern = offChainOrder.items.map(item => [item.price, item.data]);
        const feeItemPattern = offChainOrder.fees.map(item => item.map(e => [e.percentage, e.to]));

        // 以下为买方购买上面卖单中的一个资产或者多个资产  注: 上面只有一个NFT, 所以只计算一个itemHash
        const itemHash = keccak256(ethabi.encodeParameters(
            ['uint256', 'address', 'uint256', 'uint256', 'uint256',
            'uint256', 'address', 'bytes', 'tuple(uint256, bytes)', 'tuple(uint256, address)[]'],
            [
            offChainOrder.salt, offChainOrder.user, offChainOrder.network, offChainOrder.intent,
            offChainOrder.delegateType, offChainOrder.deadline, offChainOrder.currency, offChainOrder.dataMask,
            orderItemPattern[tokenIndexOfChainOrder], feeItemPattern[tokenIndexOfChainOrder]]
        ));

            // 结算参数, 对每一个order中的某个item结算的数据
        const itemIndex=tokenIndexOfChainOrder;
        if(this.orderNum==null){
            this.orderNum=0;
        }else{
            this.orderNum+=1;
        }
        let itemprice = offChainOrder.items[itemIndex].price;
        
        if(offChainOrder.currency==ZERO_ADDRESS){
          this.priceAll+=itemprice;
        }
       delete offChainOrder.originalitems;
        let op;
        if(orderType==1){
          op=1; //买单
        }
        if(orderType==3){
          op=2; //买单
        }
        if(orderType==0){
          op=3; //取消
          itemprice=0;
          this.priceAll=0;
        }
         

        const settleDetail = {
            op: op, // 1 为卖单  
            orderIdx: this.orderNum, // 下面的runInput可以传多个order, 我们上面只有一个orderInfo, index为0  留意runInput.orders
            itemIdx: itemIndex, // 一笔order中可能会有多个items, 我们上面只有一个item, 所以填0  这里的意思就是结算订单数组中为0, 且在订单中为0的NFT
            price: itemprice, // 此NFT卖家的价格 上面为1ETH
            itemHash: itemHash, // 上面计算的itemHash
            executionDelegate: this.delegateaddress, // 交易所转移资产的合约, 也是用户给该合约授权可操作NFT
            dataReplacement: '0x', // 卖单写死为0x
            bidIncentivePct: 0, // 卖单为0
            aucMinIncrementPct: 0, // 卖单为0
            aucIncDurationSecs: 0, // 卖单为0
            broker: ZERO_ADDRESS // 二级分销商的地址 如果没有分销商 该参数为ZERO_ADDRESS
        };

        this.orders.push(offChainOrder);
        this.details.push(settleDetail);


};

wapOrderdetails.prototype.getorders=function(){
    return this.orders;
 
};
wapOrderdetails.prototype.getdetails=function(){
    return this.details;
};
wapOrderdetails.prototype.addBuyorder= function(offChainOrder,tokenIndexOfChainOrder){
  const orderType=1;//匹配的是卖单
  this.adaptorder(offChainOrder,tokenIndexOfChainOrder,orderType);

};
wapOrderdetails.prototype.adaptorder= function(OrderfromServer,tokenIndexOfChainOrder,orderType){
   //这个买单匹配的是一个卖单
   

   const orderInfo = OrderfromServer;
   const signature_= orderInfo.signature;
   const signature = ethers.utils.splitSignature(signature_);
   delete orderInfo.signature;
   const makeselltoken =new getsellToken ();

  //  orderInfo.originalitems=orderInfo.items;

   orderInfo.items.forEach((item)=>{
    
    makeselltoken.addnft(item.contract_address,item.token_id, fromWei(item.price));

   });
   orderInfo.items= makeselltoken.getList();

   orderInfo.delegateType=orderInfo.delegate_type ;
   orderInfo.dataMask=orderInfo.data_mask ;
   delete orderInfo.delegate_type;
   delete orderInfo.data_mask;

   
   // 组合出线下签名的卖单数据
   const offChainOrder = {
    ...orderInfo,
    r: signature.r,
    s: signature.s,
    v: signature.v,
    signVersion: 1 // 写死为1
  };

   this.buildorder(offChainOrder,tokenIndexOfChainOrder,orderType);

};

wapOrderdetails.prototype.addSellorder= function(offChainOrder,tokenIndexOfChainOrder){
  //这个买单匹配的是一个买单
  const orderType=3;// 3 匹配的是买单
  this.adaptorder(offChainOrder,tokenIndexOfChainOrder,orderType);

};
wapOrderdetails.prototype.cancelOrder= function(offChainOrder,tokenIndexOfChainOrder){
  //这个买单匹配的是一个买单
  const orderType=0;// 0 自定义的取消匹配到的订单 
  this.adaptorder(offChainOrder,tokenIndexOfChainOrder,orderType);

};

wapOrderdetails.prototype.executeOrder = async function(library, account, chainID,expireTime){
      // 多个结算订单共享的参数
      const settleShared = {
        salt: generatePseudoRandomSalt().toString(), // 随机salt
        deadline: expireTime, // 过期时间
        amountToEth: 0, // 卖单为0
        amountToWeth: 0, // 卖单为0
        user: account, // 买家地址
        canFail: false // 如果有多个结算订单, 该参数为true, 现在我们只有一个NFT卖单, 所以为false
      };
      console.log('getorders',this.getorders());
      // 调用合约的参数
      const runInput = {
        orders: this.getorders(),
        details: this.getdetails(),
        shared: settleShared,
        r: this.getorders()[0].r, //占位
        s: this.getorders()[0].s, //占位
        v: this.getorders()[0].v  //占位
      };
      // account2为买家地址, 调用合约, 传入runInput参数
      const overrides = {value: this.priceAll};
      const eye = exchange(library, account, chainID);
      console.log(runInput, overrides);
      let result;
      // result = await eye.run(runInput, overrides);

      if(this.priceAll!=0){
         result = await eye.run(runInput, overrides);
      }else{
         result = await eye.run(runInput);
      }
      
      return result;
};



export async function buyOrder(library, account, chainID,offChainOrder,expireTime){
    const MyNftcontract = getMyNftcontract(library, account, chainID);

    const orderItemPattern = offChainOrder.items.map(item => [item.price, item.data]);
    const feeItemPattern = offChainOrder.fees.map(item => item.map(e => [e.percentage, e.to]));

    // 以下为买方购买上面卖单中的一个资产或者多个资产  注: 上面只有一个NFT, 所以只计算一个itemHash
    const itemHash = keccak256(ethabi.encodeParameters(
        ['uint256', 'address', 'uint256', 'uint256', 'uint256',
          'uint256', 'address', 'bytes', 'tuple(uint256, bytes)', 'tuple(uint256, address)[]'],
        [
         offChainOrder.salt, offChainOrder.user, offChainOrder.network, offChainOrder.intent,
         offChainOrder.delegateType, offChainOrder.deadline, offChainOrder.currency, offChainOrder.dataMask,
          orderItemPattern[0], feeItemPattern[0]]
    ));
    //授权地址
    const delegateaddress = getTokenByName(chainID,"ERC721Delegate");

    // 结算参数, 对每一个order中的某个item结算的数据
    const itemIndex=0;
    const settleDetail = {
        op: 1, // 1 为卖单
        orderIdx: 0, // 下面的runInput可以传多个order, 我们上面只有一个orderInfo, index为0  留意runInput.orders
        itemIdx: itemIndex, // 一笔order中可能会有多个items, 我们上面只有一个item, 所以填0  这里的意思就是结算订单数组中为0, 且在订单中为0的NFT
        price: offChainOrder.items[itemIndex].price, // 此NFT卖家的价格 上面为1ETH
        itemHash: itemHash, // 上面计算的itemHash
        executionDelegate: delegateaddress, // 交易所转移资产的合约, 也是用户给该合约授权可操作NFT
        dataReplacement: '0x', // 卖单写死为0x
        bidIncentivePct: 0, // 卖单为0
        aucMinIncrementPct: 0, // 卖单为0
        aucIncDurationSecs: 0, // 卖单为0
        broker: ZERO_ADDRESS // 二级分销商的地址 如果没有分销商 该参数为ZERO_ADDRESS
      };

    // 多个结算订单共享的参数
    const settleShared = {
        salt: generatePseudoRandomSalt().toString(), // 随机salt
        deadline: expireTime, // 过期时间
        amountToEth: 0, // 卖单为0
        amountToWeth: 0, // 卖单为0
        user: account, // 买家地址
        canFail: false // 如果有多个结算订单, 该参数为true, 现在我们只有一个NFT卖单, 所以为false
      };

    // 调用合约的参数
    const runInput = {
        orders: [offChainOrder],
        details: [settleDetail],
        shared: settleShared,
        r: offChainOrder.r, //占位
        s: offChainOrder.s, //占位
        v: offChainOrder.v  //占位
      };

    // account2为买家地址, 调用合约, 传入runInput参数
    const overrides = {value: offChainOrder.items[itemIndex].price};
    const eye = exchange(library, account, chainID);
    console.log(runInput, overrides);
    const result = await eye.run(runInput, overrides);


}

export async function wethbalance(library, account, chainID){
     const  wethcon = getweth(library, account, chainID);
     const data = await wethcon.balanceOf(account);
 
     return  fromWei(data.toString());

}

export async function ethToWeth(library, account, chainID,ethnum){
  const  wethcon = getweth(library, account, chainID);
  
  const data = await wethcon.deposit({value:toWei(String(ethnum) )});
  return  data;

}


export async function X2Y2approve(library, account, chainID,contractaddress,num){
  const  wethcon = getweth(library, account, chainID,contractaddress);
  //授权地址
  const AdminUpgradeabilityProxyaddress = getTokenByName(chainID,"AdminUpgradeabilityProxy");

  const data = await wethcon.approve(AdminUpgradeabilityProxyaddress,num);
  return  data;

}

export async function X2Y2allowance(library, account, chainID,contractaddress){
  const  wethcon = getweth(library, account, chainID,contractaddress);
  //授权地址
  const AdminUpgradeabilityProxyaddress = getTokenByName(chainID,"AdminUpgradeabilityProxy");

  const data = await wethcon.allowance(account,AdminUpgradeabilityProxyaddress);
  return  data.toString();

}


